import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/+.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_info_circle_yellow.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-33e42b2e")

_pushScopeId("data-v-33e42b2e")
const _hoisted_1 = {
  class: "overflow-auto relative",
  style: {"max-height":"calc(calc(100vh/var(--viewport-scale)) - 300px)"}
}
const _hoisted_2 = { class: "booking-shipment-table-parent relative" }
const _hoisted_3 = { class: "py-2 border-t border-b border-gray-lp-1400" }
const _hoisted_4 = { class: "w-9 sticky top-0 bg-white" }
const _hoisted_5 = { class: "text-sm font-bold w-8 pl-3 text-left py-2 col" }
const _hoisted_6 = { class: "w-44 sticky top-0 bg-white" }
const _hoisted_7 = { class: "flex flex-col gap-0 text-sm text-left pl-4 w-51 py-2 row-center" }
const _hoisted_8 = { class: "font-bold text-black-lp-100 leading-none" }
const _hoisted_9 = { class: "text-gray-lp-600 font-normal leading-none" }
const _hoisted_10 = { class: "w-44 sticky top-0 bg-white" }
const _hoisted_11 = { class: "flex flex-col gap-1 text-sm text-left pl-4 w-44 py-2 row-center" }
const _hoisted_12 = { class: "font-bold text-black-lp-100 leading-none" }
const _hoisted_13 = { class: "text-gray-lp-600 font-normal leading-none" }
const _hoisted_14 = { class: "w-32 sticky top-0 bg-white" }
const _hoisted_15 = { class: "flex flex-col gap-1 text-sm text-left pl-4 pr-3 w-28 py-2 row-center" }
const _hoisted_16 = { class: "font-bold text-black-lp-100 leading-none" }
const _hoisted_17 = { class: "text-gray-lp-600 font-normal leading-none" }
const _hoisted_18 = { class: "w-28 sticky top-0 bg-white" }
const _hoisted_19 = { class: "text-sm font-bold w-28 pl-4 text-left py-2" }
const _hoisted_20 = { class: "w-44 sticky top-0 bg-white" }
const _hoisted_21 = { class: "text-sm font-bold pl-4 text-left py-2" }
const _hoisted_22 = { class: "w-64 sticky top-0 bg-white" }
const _hoisted_23 = {
  class: "text-sm font-bold pl-4 pr-3 text-right py-2 justify-end",
  style: {"justify-content":"end"}
}
const _hoisted_24 = { colspan: 99 }
const _hoisted_25 = { class: "w-full booking-shipment-table" }
const _hoisted_26 = {
  colspan: 99,
  style: {"height":"100%"}
}
const _hoisted_27 = { class: "flex flex-row justify-between items-center rounded-tl-xl rounded-tr-xl bg-gray-lp-1000 py-2 px-3 border-t border-l border-r border-gray-lp-1400" }
const _hoisted_28 = {
  key: 0,
  class: "flex flex-row gap-2.5 items-center"
}
const _hoisted_29 = { class: "text-black-lp-100 font-bold" }
const _hoisted_30 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "add"
}, null, -1)
const _hoisted_31 = {
  key: 0,
  class: "bg-yellow-lp-1700"
}
const _hoisted_32 = {
  colspan: "99",
  style: {"height":"auto"}
}
const _hoisted_33 = { src: _imports_1 }
const _hoisted_34 = { class: "w-9 mt-2" }
const _hoisted_35 = {
  class: "w-9 pl-3 col text-black-lp-100",
  style: {"justify-content":"flex-start","align-items":"center"}
}
const _hoisted_36 = { class: "w-44" }
const _hoisted_37 = { class: "w-44 flex flex-col gap-1 pl-4 text-sm col" }
const _hoisted_38 = { class: "flex flex-row gap-1 items-center leading-none" }
const _hoisted_39 = {
  class: "text-sm text-black-lp-100 leading-none flex flex-row items-center gap-1",
  style: {"height":"17px"}
}
const _hoisted_40 = {
  style: {"height":"17px"},
  class: "text-gray-lp-800 leading-none"
}
const _hoisted_41 = { class: "w-44" }
const _hoisted_42 = { class: "w-44 flex flex-col gap-1 pl-4 text-sm col" }
const _hoisted_43 = { class: "flex flex-row gap-1 items-center leading-none" }
const _hoisted_44 = {
  class: "text-sm text-black-lp-100 leading-none",
  style: {"height":"17px"}
}
const _hoisted_45 = {
  style: {"height":"17px"},
  class: "text-gray-lp-800 leading-none"
}
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_48 = { class: "w-32" }
const _hoisted_49 = { class: "flex flex-col gap-1 pl-4 text-sm w-full col" }
const _hoisted_50 = { class: "flex flex-row gap-1 items-center leading-none" }
const _hoisted_51 = {
  class: "text-sm text-black-lp-100 leading-none",
  style: {"height":"17px"}
}
const _hoisted_52 = {
  class: "text-gray-lp-800 leading-none w-full",
  style: {"height":"17px"}
}
const _hoisted_53 = { class: "flex flex-row gap-1 items-center leading-none" }
const _hoisted_54 = {
  class: "text-sm text-black-lp-100 leading-none",
  style: {"height":"17px"}
}
const _hoisted_55 = {
  class: "text-gray-lp-800 leading-none w-full",
  style: {"height":"17px"}
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_57 = { class: "w-28 flex flex-col gap-1 pl-4 text-sm col" }
const _hoisted_58 = {
  key: 0,
  class: "flex flex-row gap-1 items-center leading-none"
}
const _hoisted_59 = {
  class: "text-sm text-black-lp-100 leading-none",
  style: {"height":"17px"}
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_61 = { class: "w-44" }
const _hoisted_62 = { class: "w-44 flex flex-col gap-1 pl-4 text-sm col" }
const _hoisted_63 = { class: "flex flex-row gap-1 items-center" }
const _hoisted_64 = { class: "w-64" }
const _hoisted_65 = { class: "w-full flex flex-row gap-2 pl-4 text-sm justify-end pr-3 col" }
const _hoisted_66 = {
  key: 2,
  class: "relative"
}
const _hoisted_67 = {
  key: 0,
  class: "absolute top-0 left-1/3 bg-red-lp-2400 rounded-lg py-0.5 px-1 text-8px font-medium text-white -mt-1",
  style: {"line-height":"1"}
}
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { colspan: 99 }
const _hoisted_70 = { class: "py-12" }
const _hoisted_71 = { class: "flex flex-col text-sm" }
const _hoisted_72 = { class: "shipment-print-option-icon" }
const _hoisted_73 = { class: "shipment-print-option-icon" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_EmptyList = _resolveComponent("EmptyList")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("table", _hoisted_2, [
        _createVNode("thead", _hoisted_3, [
          _createVNode("tr", null, [
            _createVNode("th", _hoisted_4, [
              _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.no")), 1)
            ]),
            _createVNode("th", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.shipmentBookingId")), 1),
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.noStt")), 1)
              ])
            ]),
            _createVNode("th", _hoisted_10, [
              _createVNode("div", _hoisted_11, [
                _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.productType")), 1),
                _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.chargeableWeight")), 1)
              ])
            ]),
            _createVNode("th", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode("div", _hoisted_16, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.weightPieces")), 1),
                _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.dimension")), 1)
              ])
            ]),
            _createVNode("th", _hoisted_18, [
              _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.totalTariff")), 1)
            ]),
            _createVNode("th", _hoisted_20, [
              _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.bookingStatus")), 1)
            ]),
            _createVNode("th", _hoisted_22, [
              _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.action")), 1)
            ])
          ])
        ]),
        _createVNode(_TransitionGroup, {
          class: "overflow-hidden",
          tag: "tbody",
          name: "list"
        }, {
          default: _withId(() => [
            (_ctx.shipmentData.length)
              ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.shipmentData, (group, groupIdx) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: group.shipmentId
                  }, [
                    _createVNode("td", _hoisted_24, [
                      _createVNode("table", _hoisted_25, [
                        _createVNode("tbody", null, [
                          (_ctx.isRenderHeadGroup(group.shipmentId))
                            ? (_openBlock(), _createBlock("tr", {
                                key: 0,
                                "data-testid": `booking-shipment-table-group-header-${group.shipmentId}`
                              }, [
                                _createVNode("td", _hoisted_26, [
                                  _createVNode("div", _hoisted_27, [
                                    _createVNode("div", {
                                      class: ["font-bold", [
                            { 'text-blue-lp-300': _ctx.isApAs(group.shipmentId) },
                            { 'text-aqua-lp-500': !_ctx.isApAs(group.shipmentId) }
                          ]]
                                    }, _toDisplayString(group.shipmentId), 3),
                                    (_ctx.isApAs(group.shipmentId))
                                      ? (_openBlock(), _createBlock("div", _hoisted_28, [
                                          _createVNode("div", _hoisted_29, _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.addAddress")), 1),
                                          _createVNode("button", {
                                            "data-testid": `booking-shipment-table-button-add-recipient-${group.shipmentId}`,
                                            style: {"background-color":"#EABCBE"},
                                            class: "w-6 rounded-full text-red-lp-100 text-xl font-medium",
                                            onClick: ($event: any) => (_ctx.addAddress(group.shipmentId))
                                          }, [
                                            _hoisted_30
                                          ], 8, ["data-testid", "onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ], 8, ["data-testid"]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.data, (item, index) => {
                            return (_openBlock(), _createBlock(_Fragment, {
                              key: item.id
                            }, [
                              (item.STT?.sttCreatedName && _ctx.isShowExistBooked)
                                ? (_openBlock(), _createBlock("tr", _hoisted_31, [
                                    _createVNode("td", _hoisted_32, [
                                      _createVNode("div", {
                                        class: ["w-full border-l border-r border-t border-gray-lp-1400", [
                            {
                              'rounded-tl-2xl rounded-tr-2xl': !_ctx.isRenderHeadGroup(
                                group.shipmentId
                              )
                            }
                          ]]
                                      }, [
                                        _createVNode("div", {
                                          class: ["flex flex-row items-center text-sm px-2 py-0.5 text-yellow-lp-1600 gap-1 bg-yellow-lp-1800 font-medium rounded-br-2xl", [
                              {
                                'rounded-tl-2xl': !_ctx.isRenderHeadGroup(
                                  group.shipmentId
                                )
                              }
                            ]],
                                          style: {"width":"max-content"}
                                        }, [
                                          _createVNode("div", null, _toDisplayString(_ctx.$t("dispatch.scanErrorAlreadyBookedLabel")), 1),
                                          _withDirectives(_createVNode("img", _hoisted_33, null, 512), [
                                            [
                                              _directive_tooltip,
                                              
                                `Shipment dibooking pada ${_ctx.formatDate(
                                  item.STT.sttCreatedAt,
                                  'DD MMM YYYY, HH:mm'
                                )} oleh ${item.STT.sttCreatedName}`
                              ,
                                              void 0,
                                              { top: true }
                                            ]
                                          ])
                                        ], 2)
                                      ], 2)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode("tr", {
                                "data-testid": `booking-shipment-table-row-${item.shipmentId || item.shipmentAlgoId || group.shipmentId}-${item.id}`,
                                class: [
                        { 'last-child': index === group.data.length - 1 },
                        { 'non-group': !_ctx.isRenderHeadGroup(group.shipmentId) },
                        {
                          'already-booked':
                            item.STT?.sttCreatedName && _ctx.isShowExistBooked
                        }
                      ]
                              }, [
                                _createVNode("td", _hoisted_34, [
                                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.totalAllItems.length -
                              (_ctx.indexOffset(groupIdx) + index)), 1)
                                ]),
                                _createVNode("td", _hoisted_36, [
                                  _createVNode("div", _hoisted_37, [
                                    _createVNode("div", _hoisted_38, [
                                      _createVNode("div", _hoisted_39, [
                                        _createTextVNode(_toDisplayString(item.shipmentId ||
                                  item.STT?.shipmentAlgoId ||
                                  item.shipmentAlgoId) + " ", 1),
                                        (_ctx.renderDeliveryType(item))
                                          ? (_openBlock(), _createBlock("img", {
                                              key: 0,
                                              style: {"height":"9px"},
                                              src: _ctx.renderDeliveryType(item),
                                              alt: ""
                                            }, null, 8, ["src"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createVNode("div", _hoisted_40, _toDisplayString(item.STT?.sttNo || "-"), 1)
                                  ])
                                ]),
                                _createVNode("td", _hoisted_41, [
                                  _createVNode("div", _hoisted_42, [
                                    (
                              item.STT?.sttProductType || item.shipmentProduct
                            )
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                          _createVNode("div", _hoisted_43, [
                                            _createVNode("div", _hoisted_44, _toDisplayString(_ctx.mapProductTypeName(
                                    item.STT?.sttProductType ||
                                      item.shipmentProduct
                                  )), 1)
                                          ]),
                                          _createVNode("div", _hoisted_45, [
                                            (item.STT?.sttChargeableWeight)
                                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                                  _createTextVNode(_toDisplayString(_ctx.formatWeight(item.STT.sttChargeableWeight)), 1)
                                                ], 64))
                                              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                                  _hoisted_46
                                                ], 64))
                                          ])
                                        ], 64))
                                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                          _hoisted_47
                                        ], 64))
                                  ])
                                ]),
                                _createVNode("td", _hoisted_48, [
                                  _createVNode("div", _hoisted_49, [
                                    (item.STT?.sttProductType)
                                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                          _createVNode("div", _hoisted_50, [
                                            _createVNode("div", _hoisted_51, _toDisplayString(_ctx.formatWeight(
                                    item.STT?.sttPieces.reduce(
                                      (prev, curr) =>
                                        prev + curr.stt_piece_gross_weight,
                                      0
                                    )
                                  )) + "/" + _toDisplayString(_ctx.formatQuantity(item.STT?.sttPieces.length)) + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.piece")), 1)
                                          ]),
                                          _createVNode("div", _hoisted_52, _toDisplayString(_ctx.formatWeight(
                                  item.STT.sttPieces[0].stt_piece_length
                                )) + " x " + _toDisplayString(_ctx.formatWeight(
                                  item.STT.sttPieces[0].stt_piece_width
                                )) + " x " + _toDisplayString(_ctx.formatWeight(
                                  item.STT.sttPieces[0].stt_piece_height
                                )) + " cm ", 1)
                                        ], 64))
                                      : (item.shipmentGoodDetail.length)
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                            _createVNode("div", _hoisted_53, [
                                              _createVNode("div", _hoisted_54, _toDisplayString(_ctx.formatWeight(
                                    item.shipmentGoodDetail.reduce(
                                      (prev, curr) =>
                                        prev + curr.shipment_goods_weight,
                                      0
                                    )
                                  )) + "/" + _toDisplayString(_ctx.formatQuantity(
                                    item.shipmentGoodDetail.length
                                  )) + "koli ", 1)
                                            ]),
                                            _createVNode("div", _hoisted_55, _toDisplayString(_ctx.formatWeight(
                                  item.shipmentGoodDetail[0]
                                    .shipment_goods_length
                                )) + " x " + _toDisplayString(_ctx.formatWeight(
                                  item.shipmentGoodDetail[0]
                                    .shipment_goods_width
                                )) + " x " + _toDisplayString(_ctx.formatWeight(
                                  item.shipmentGoodDetail[0]
                                    .shipment_goods_height
                                )) + " cm ", 1)
                                          ], 64))
                                        : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                            _hoisted_56
                                          ], 64))
                                  ])
                                ]),
                                _createVNode("td", {
                                  class: "w-28",
                                  "data-testid": `booking-shipment-table-column-total-tarif-${item.id}`
                                }, [
                                  _createVNode("div", _hoisted_57, [
                                    (item.STT?.sttProductType)
                                      ? (_openBlock(), _createBlock("div", _hoisted_58, [
                                          _createVNode("div", _hoisted_59, _toDisplayString(item.STT.sttTotalAmount ? _ctx.isC1OrC2(item.shipmentId || item.shipmentAlgoId) ? "-"
                                    : _ctx.isCA(item.shipmentId) ? _ctx.formatPrice(item.STT.sttTotalAmount)
                                      : _ctx.formatHidePrice
                                    : "-"), 1)
                                        ]))
                                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                          _hoisted_60
                                        ], 64))
                                  ])
                                ], 8, ["data-testid"]),
                                _createVNode("td", _hoisted_61, [
                                  _createVNode("div", _hoisted_62, [
                                    _createVNode("div", _hoisted_63, [
                                      _createVNode("div", {
                                        "data-testid": `booking-shipment-table-status-badge-${item.id}`,
                                        class: ["text-sm px-2 rounded-2xl font-medium py-0.5", 
                                _ctx.mapBookingStatus(item.STT?.sttNo, item.error)
                                  .class
                              ]
                                      }, _toDisplayString(_ctx.mapBookingStatus(item.STT?.sttNo, item.error)
                                  .text), 11, ["data-testid"])
                                    ])
                                  ])
                                ]),
                                _createVNode("td", _hoisted_64, [
                                  _createVNode("div", _hoisted_65, [
                                    (!!item.STT?.sttNo)
                                      ? (_openBlock(), _createBlock(_component_LpButton, {
                                          key: 0,
                                          "data-testid": `booking-shipment-table-button-print-${item.id}`,
                                          class: "shipment-table-action-btn print",
                                          title: "Print",
                                          color: "red-lp-2400",
                                          textColor: "red-lp-2400",
                                          outline: "",
                                          iconV2: "",
                                          icon: "chevron-down",
                                          iconColor: "red-lp-2400",
                                          small: "",
                                          onClick: ($event: any) => (_ctx.togglePrintPanel($event, item.STT.sttId, item.STT.sttNo, item.id))
                                        }, null, 8, ["data-testid", "onClick"]))
                                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                          (!item.isInstantBooking || item.error)
                                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                                key: 0,
                                                "data-testid": `booking-v3-shipment-table-button-booking-${item.id}`,
                                                class: "shipment-table-action-btn booking",
                                                customClass: "p-2",
                                                title: "Booking",
                                                color: "red-lp-2400",
                                                textColor: "white",
                                                small: "",
                                                onClick: ($event: any) => (_ctx.bookingShipment(item.shipmentId || item.shipmentAlgoId, item.id, _ctx.bookingVersion))
                                              }, null, 8, ["data-testid", "onClick"]))
                                            : _createCommentVNode("", true),
                                          (
                                (!item.isInstantBooking || item.error) &&
                                  _ctx.isBookingMarketplaceV3
                              )
                                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                                key: 1,
                                                "data-testid": `booking-shipment-table-button-edit-${item.id}`,
                                                class: "shipment-table-action-btn",
                                                customClass: "p-2",
                                                color: "red-lp-2400",
                                                textColor: "red-lp-2400",
                                                outline: "",
                                                iconV2: "",
                                                icon: "pencil-edit",
                                                iconColor: "red-lp-2400",
                                                small: "",
                                                onClick: ($event: any) => (_ctx.editShipment(item.shipmentId, item.id, 'v3'))
                                              }, null, 8, ["data-testid", "onClick"]))
                                            : _createCommentVNode("", true),
                                          (
                                (!item.isInstantBooking || item.error) &&
                                  _ctx.isBookingMarketplaceV4
                              )
                                            ? (_openBlock(), _createBlock("div", _hoisted_66, [
                                                _createVNode(_component_LpButton, {
                                                  "data-testid": `booking-shipment-table-button-edit-v4-${item.id}`,
                                                  class: "shipment-table-action-btn",
                                                  customClass: "p-2",
                                                  color: "red-lp-2400",
                                                  textColor: "red-lp-2400",
                                                  outline: "",
                                                  iconV2: "",
                                                  icon: "pencil-edit",
                                                  iconColor: "red-lp-2400",
                                                  small: "",
                                                  onClick: ($event: any) => (_ctx.editShipment(item.shipmentId, item.id, 'v4'))
                                                }, null, 8, ["data-testid", "onClick"]),
                                                (_ctx.isBookingMarketplaceV3)
                                                  ? (_openBlock(), _createBlock("span", _hoisted_67, " New "))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (!item.isInstantBooking || item.error)
                                            ? (_openBlock(), _createBlock(_component_LpButton, {
                                                key: 3,
                                                "data-testid": `booking-shipment-table-button-hapus-${item.id}`,
                                                class: "shipment-table-action-btn",
                                                customClass: "p-2",
                                                color: "red-lp-2400",
                                                textColor: "red-lp-2400",
                                                outline: "",
                                                iconV2: "",
                                                icon: "delete",
                                                iconColor: "red-lp-2400",
                                                small: "",
                                                onClick: ($event: any) => (_ctx.deleteShipment(item.shipmentId, item.id))
                                              }, null, 8, ["data-testid", "onClick"]))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ])
                                ])
                              ], 10, ["data-testid"])
                            ], 64))
                          }), 128))
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              : (_openBlock(), _createBlock("tr", _hoisted_68, [
                  _createVNode("td", _hoisted_69, [
                    _createVNode("div", _hoisted_70, [
                      _createVNode(_component_EmptyList, {
                        icon: "ill_spot_search",
                        customHeaderMessage: 
                    _ctx.$t('bookingShipment.appsMarketplace.dataNotFound')
                  ,
                        customMessage: 
                    _ctx.$t('bookingShipment.appsMarketplace.filterNotMatch')
                  
                      }, null, 8, ["customHeaderMessage", "customMessage"])
                    ])
                  ])
                ]))
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "shipment-booking-print",
      "data-testid": `booking-shipment-table-print-overlay-${_ctx.printRowId}`,
      style: {"font-family":"Montserrat","padding":"0px"},
      class: "shipment-booking-overlay shipment-booking-row-print-overlay"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_71, [
          _createVNode("button", {
            class: "shipment-print-button-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.print('thermal-pdf')))
          }, [
            _createVNode("span", _hoisted_72, [
              _createVNode(_component_Icons, { name: "printer" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.printReceiptA6")), 1)
          ]),
          _createVNode("button", {
            class: "shipment-print-button-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.print('print-basic')))
          }, [
            _createVNode("span", _hoisted_73, [
              _createVNode(_component_Icons, { name: "printer" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingShipment.appsMarketplace.printReceiptA4")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["data-testid"])
  ], 64))
})